import React, { useCallback, type MouseEvent, type KeyboardEvent } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ListItemMenuOptionProps } from '@atlassian/jira-software-roadmap-timeline-table/src/renderers/index.tsx';
import messages from './messages.tsx';

type Props = {
	id: IssueId;
	Option: ListItemMenuOptionProps['Option'];
	setOpenModal: (event: MouseEvent | KeyboardEvent) => void;
};

const EditDependencyOption = ({ Option, setOpenModal }: Props) => {
	const { formatMessage } = useIntl();

	const onClick = useCallback(
		(event: MouseEvent | KeyboardEvent) => {
			event.preventDefault();
			setOpenModal(event);
		},
		[setOpenModal],
	);

	return <Option label={formatMessage(messages.editDependencies)} onClick={onClick} />;
};

export default EditDependencyOption;
